module.exports = __webpack_public_path__ + "static/media/augusto-del-grosso.947f89e6.jpg";